import netcoServer from '../../apis/netcoServer';
import {NETCO_CODES_REGISTRATION, INFO_SHOW} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import checkBasicAuthentication from "./checkBasicAuthentication";
import _ from "lodash";
import loadingCall from "../helpers/loadingCall";

const netcoCodesRegistration= (formValues) => async (dispatch) => {
  if(formValues.password === formValues.password_confirmation) {
    let response = await loadingCall(dispatch, () => netcoServer.newPost('/UserService/netcoCodesRegistration', formValues));
    handleResponse(dispatch, response, NETCO_CODES_REGISTRATION, onSuccessPayload, '/', [() => checkBasicAuthentication(_.pick(formValues, ['userName', 'password','redirect','uniqueID','createUser']))]);
  } else {
    dispatch({type: INFO_SHOW, payload: infoPayload('error', 'Las claves deben coincidir!')})
  }
};

const onSuccessPayload = () => {
  return infoPayload('success', 'Registro completado satisfactoriamente!');
};
export default netcoCodesRegistration;